/* Library */
import React, { Component } from 'react';
import _ from 'lodash';
import SelectionTabWithLabel from'../../../../../components/ZUILib/SelectionTabWithLabel';

// import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import TextInput from '../../../../../components/ZUILib/TextInput';
import CheckBox from '../../../../../components/ZUILib/CheckBox/CheckBox';

import commonUtil from '../../../../../utils/commonUtil';
import { eventType, ownerLabel, constChannel } from '../../../../../utils/clientConstant';
import { createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';

const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();

export default class EventOwnerDataTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSectionVisible: '',
      cellularXvAnos: this.props.userData?.phoneXvAnos || '',
      emailXvAnos: this.props.userData?.emailXvAnos || '',
      babyFirstName: this.props.userData?.firstName || '',
      firstName: this.props.userData?.firstName || '',
      lastName: this.props.userData?.lastName || '',
      motherName: this.props.userData?.motherName || '',
    };
    this.handlePopUp = this.handlePopUp.bind(this);
    this.formData = {
      userData: {
        ownerLabel: '',
        profileId: '',
        firstName: '',
        lastName: '',
        isMinor: '',
        coOwner: '',
        phoneXvAnos: '',
        emailXvAnos: '',
        titleCelebrity: '',
        motherName: '',
        celebrity:''
      },
    };
  }

  componentDidMount() {
    if (this.props.eventName === eventType.XV_Anos) {
      if (this.props.userData && this.props.userData.phoneXvAnos) {
        this.showEmailData.setChecked(true);
        this.permitAccess();
      }
    }
    if (this.props.isChanged) {
      if( this.props.userData && this.props.userData.titleCelebrity) {
      this.setState({ isSectionVisible: this.props.userData.titleCelebrity });
      }else{
        this.setState({ isSectionVisible: this.props.eventName === eventType.Open_House ? "Yo estoy estrenando" :"Yo soy el festejado" });
      }
    }
    if (channel === 'wap') {
    document.addEventListener('click', this.handleClickOutside);
  }
  }

  componentWillUnmount() {
  if (channel === 'wap') {
    document.removeEventListener('click', this.handleClickOutside);
  }
}

  getformData = () => this.formData.userData;

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  };

  handleAllowOnlyDigit = (e) => {
    const keyCode = e.charCode;
    if (keyCode > 37 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  };

  permitAccess = () => {
    if (this.showEmailData.isChecked()) {
      this.forCheck.style.display = 'block';
    } else {
      this.forCheck.style.display = 'none';
      this.cellularXvAnos.setValue('');
      this.emailXvAnos.setValue('');
    }
    this.props.onChange();
  };

  handleFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    this.props.onChange();
    switch (name) {
      case "cellularXvAnos":
        if(this.cellularXvAnos && this.cellularXvAnos.clearError){
          this.cellularXvAnos.clearError();
        }
        break;
      case "emailXvAnos":
        if(this.emailXvAnos){
          this.props.setEmailErrorCelebrity("");
          if(this.emailXvAnos.clearError){
            this.emailXvAnos.clearError();
          }
        }
        break;
      case "firstName":
        if(this.nombre4events && this.nombre4events.clearError){
          this.nombre4events.clearError();
        }
        break;
      case "lastName":
        if(this.primer4events && this.primer4events.clearError){
          this.primer4events.clearError();
        }
      
      default:
        break;
    }
  };

  handleformValidate = () => {
    const ownerEmailId = this.props.ownerEmailId ? this.props.ownerEmailId : null;
    const coOwnerEmailId = this.props.coOwnerEmailId ? this.props.coOwnerEmailId : null;
    let firstName = '';
    let lastName = '';
    let isFormValid = true;
    let title4EventsValid = true;
    let primer4EventsValid = true;
    let SegundoValid = true;
    let nombre4EventsValid = true;
    let emailXvAnosValid = true;
    let cellularXvAnosValid = true;
    let babyFirstNameValid = true;
    const configurationNumber = Number(commonUtil.getLabel(this.props?.lables?.createEventStep1, 'createEventStep1.inputconfiguration.number'))

    const is4Events = this.props.eventName === eventType.Other_Religious_Ceremonies ||
      this.props.eventName === eventType.Others ||
      this.props.eventName === eventType.Cumpleanos ||
      this.props.eventName === eventType.Open_House;

    if (this.props.eventName === eventType.XV_Anos) {
      if (this.showEmailData.isChecked()) {
        const CellularValidationRules = [
          { functionRef: commonUtil.validateLength, funcData: [this.cellularXvAnos.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.isValueAvailable, funcData: [this.cellularXvAnos.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.validateNumber, funcData: [this.cellularXvAnos.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        ];

        cellularXvAnosValid = commonUtil.validateTextInput(CellularValidationRules, this.cellularXvAnos, null);

        const emailValue = this.emailXvAnos.getValue();

        const emailXvAnosValidationRules = [
          { functionRef: commonUtil.validateLength, funcData: [emailValue, configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.isValueAvailable, funcData: [emailValue], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.validateEmail, funcData: [emailValue], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
          { functionRef: commonUtil.compareEmail, funcData: [emailValue, ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error2') },
          ...(coOwnerEmailId ? [{ functionRef: commonUtil.compareEmail, funcData: [emailValue, coOwnerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error2') }] : []),
        ];
        emailXvAnosValid = commonUtil.validateTextInput(emailXvAnosValidationRules, this.emailXvAnos, null);
      }
    }

    if (is4Events || this.props.eventName === eventType.XV_Anos || this.props.eventName === eventType.Baptism || this.props.eventName === eventType.Mascotas) {
      if (is4Events) {
        const titleValidValidationConfig = {
          functionRef: commonUtil.validateSelectedValue,
          funcData: [this.title4tabs.getSelectedIndex()],
          errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
        };
        title4EventsValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title4tabs, null);
      }
      if (this.state.isSectionVisible === "Estoy celebrando a alguien más" || this.props.eventName === eventType.XV_Anos || this.props.eventName === eventType.Baptism || this.props.eventName === eventType.Mascotas) {
        if (this.props.eventName !== eventType.Mascotas) {
          const primerValidationRules = [
            { functionRef: commonUtil.validateLength, funcData: [this.primer4events.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
            { functionRef: commonUtil.isValueAvailable, funcData: [this.primer4events.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
            { functionRef: commonUtil.validateName, funcData: [this.primer4events.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
          ];
          primer4EventsValid = commonUtil.validateTextInput(primerValidationRules, this.primer4events, null);
        }
        const nombreValidationRules = [
          { functionRef: commonUtil.validateLength, funcData: [this.nombre4events.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.isValueAvailable, funcData: [this.nombre4events.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
          { functionRef: commonUtil.validateName, funcData: [this.nombre4events.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        ];
        nombre4EventsValid = commonUtil.validateTextInput(nombreValidationRules, this.nombre4events, null);
      }
    }
if(this?.segundo4events?.getValue()) {
    const SegundoValidValidationRules = [
            { functionRef: commonUtil.validateLength, funcData: [this.segundo4events.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
            { functionRef: commonUtil.validateName, funcData: [this.segundo4events.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') }
          ];
    SegundoValid = commonUtil.validateTextInput(SegundoValidValidationRules, this.segundo4events, null);
}

if(this?.babyFirstName?.getValue()) {
    const babyFirstNameValidValidationRules = [
            { functionRef: commonUtil.validateLength, funcData: [this.babyFirstName.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
           { functionRef: commonUtil.validateName, funcData: [this.babyFirstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
          ];
    babyFirstNameValid = commonUtil.validateTextInput(babyFirstNameValidValidationRules, this.babyFirstName, null);
}

    if (primer4EventsValid && this.primer4events && this.primer4events.getValue()) {
      lastName = this.primer4events.getValue();
    }

    if (nombre4EventsValid && this.nombre4events && this.nombre4events.getValue()) {
      firstName = this.nombre4events.getValue();
    }

    isFormValid =
      title4EventsValid &&
      primer4EventsValid &&
      nombre4EventsValid &&
      emailXvAnosValid &&
      SegundoValid &&
      babyFirstNameValid &&
      cellularXvAnosValid;

    if (isFormValid) {
        const userData = {
            // ownerLabel: this.props.eventDetail?.labels?.[this.props.index] || '',
            // profileId: this.props?.userData?.profileId || '',
            // isMinor: 'false',
            coOwner: 'false',
            celebrity: 'true'
        };

        // Add fields only if they exist and have values
        if (this.primer4events?.getValue()) userData.lastName = this.primer4events.getValue();
        if (this.nombre4events?.getValue()) userData.firstName = this.nombre4events.getValue();
        
        // Event-specific fields
        if (this.props.eventName === eventType.Bebe) {
            userData.firstName = this.babyFirstName?.getValue();
        }
        
        if (this.props.eventName === eventType.XV_Anos && this.showEmailData?.isChecked()) {
            if (this.cellularXvAnos?.getValue()) userData.phoneXvAnos = this.cellularXvAnos.getValue();
            if (this.emailXvAnos?.getValue()) userData.emailXvAnos = this.emailXvAnos.getValue();
        }
        
        if (is4Events && this.title4tabs?.getValue()) {
            userData.titleCelebrity = this.title4tabs.getValue();
        }
        
        if (this.segundo4events?.getValue()) {
            userData.motherName = this.segundo4events.getValue();
        }

        this.formData = { userData };
        return true;
    }

    const controls = [
      this.title4tabs,
      this.nombre4events,
      this.primer4events,
      this.cellularXvAnos,
      this.emailXvAnos
    ];

    const tagCompositor = c => ({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      color: 'Rojo',
      mensaje: 'Datos incompletos del administrador',
      mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
      seccion: 'Mesa de Regalos',
      tipo: 'formulario',
    });

    createTagsForInvalidFormControls({ controls, tagCompositor });

    // if (!title4EventsValid) {
    //   this.props.focusOnError('title4tabs');
    // } else if (!primer4EventsValid) {
    //   this.props.focusOnError('primer4tabs');
    // } else if (!nombre4EventsValid) {
    //   this.props.focusOnError('nombre4tabs');
    // } else if (!emailXvAnosValid) {
    //   this.props.focusOnError('emailXvAnos');
    // } else if (!cellularXvAnosValid) {
    //   this.props.focusOnError('cellularXvAnos');
    // }
    return false;
  };

  handlePopUp(e,id){
    if (channel === 'wap') {
      e.stopPropagation();
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  };
  
  handleClickOutside = (e) => {
  if (channel === 'wap') {
    const tooltip = document.querySelector('#helpPopup');    
    if (tooltip && !tooltip.contains(e.target) && tooltip.style.display === 'block') {
      tooltip.style.display = 'none';
    }
  }
}
  setValueOption = (opt) => {
    this.setState({ isSectionVisible: opt.value } , () => {
        if (this.title4tabs && this.title4tabs.clearError) {
            this.title4tabs.clearError();
        }
        this.props.onChange();

        if (opt.value === "Yo soy el festejado" || opt.value === "Yo estoy estrenando") {
            this.nombre4events.setValue('');
            this.primer4events.setValue('');
            this.segundo4events.setValue('');
        }
    });
  };

  getInputClass = ref => {
    if (ref && (ref.props.disabled === 'disabled')) {
      return 'tags-disabled';
    }
    return 'tags-active';
  };

  render() {
    const { eventDetail, userData, lables, emailErrorCelebrity } = this.props;

    const is4Events = this.props.eventName === eventType.Other_Religious_Ceremonies ||
      this.props.eventName === eventType.Others ||
      this.props.eventName === eventType.Cumpleanos ||
      this.props.eventName === eventType.Open_House;

    let SelectionOptionsValue = ["Estoy celebrando a alguien más", "Yo soy el festejado"];
    if( this.props.eventName === eventType.Open_House ){
      SelectionOptionsValue = ["Estoy celebrando a alguien más", "Yo estoy estrenando"];
    }
    
    let SelectionOptions = [];
    SelectionOptions = SelectionOptionsValue.map((data) => {
      const title = {};
      title.id = data;
      title.labelResourceId = data;
      title.value = data;
      return title;
    });

    return (
      <React.Fragment>
        <style>
          {`
          `}
        </style>
        <div className='Section_One_Container'>
          { this.props.eventName === eventType.Bebe &&
          <div className='sectionOneABebe'>
            <>
              <div className="text-right labelStyle1"><span>{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.camposObligatoros.label')}</span></div>
              <div className="formBlock headerTitleB">
                <h2 className={channel === 'wap' ? 'articleName' : 'subtitleModuleBoda titleForm'}>
                  {/* {(this.props.eventName === eventType.Bebe) ? commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.comoseLaama.label') : commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.quienCelebramos.label')} */}
                  {this.props.getFormHeadingLabelByEventType(this.props.eventName, 'left')}
                </h2>
              </div>
              <div className="formBlock">
                <TextInput
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  parentClassName={this.getInputClass(this.txtMotherName)}
                  htmlId="middlename"
                  label="Primer nombre de tu bebé"
                  required="true"
                  maxlength="100"
                  name="firstName"
                  value={this.state.firstName}
                  onChange={this.handleFieldChange}
                  ref={babyFirstName => (this.babyFirstName = babyFirstName)}
                  createEvent={true}
                />
              </div>
              <p className='Bebe_underTxt'>{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.noSeObligator.label')}</p>
            </>
          </div>
          }
          <div className='sectionOneA4' style={{ display: (is4Events || this.props.eventName === eventType.XV_Anos || this.props.eventName === eventType.Baptism || this.props.eventName === eventType.Mascotas) ? 'block' : 'none' }}>
            <div className="text-right labelStyle1"><span>{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.camposObligatoros.label')}</span></div>
            <div className="formBlock headerTitleB">
              <h2 className={channel === 'wap' ? 'articleName' : 'subtitleModule titleForm'}>
                {/* {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.quienCelebramos.label')} */}
                {this.props.getFormHeadingLabelByEventType(this.props.eventName, 'left')}
              </h2>
            </div>
            {is4Events &&
              <div className="formBlock">
                <SelectionTabWithLabel
                  htmlId={'id_owner'}
                  id="title4tabs"
                  classname="cSelect required"
                  options={SelectionOptions}
                  optionCaption={'Selecciona una opción'}
                  optionText={'labelResourceId'}
                  optionValue={'value'}
                  value={userData ? userData.titleCelebrity : this.props.isChanged ? (this.props.eventName === eventType.Open_House ? "Yo estoy estrenando" : "Yo soy el festejado") : ""}
                  star="*"
                  required="true"
                  handleSelectedOption={this.setValueOption}
                  ref={el => (this.title4tabs = el)}
                  enable={SelectionOptions.length > 0}
                  src={commonUtil.getAssetURL() + '/images/expand_more.svg'}
                />
              </div>
            }
            <div className="formBlock" style={{ display: `${(this.props.eventName === eventType.XV_Anos || this.props.eventName === eventType.Baptism || this.props.eventName === eventType.Mascotas) ? 'block' : this.state.isSectionVisible === "Estoy celebrando a alguien más" ? 'block' : 'none'}` }}>
              <div className="formBlock headerTitleB margintop-24">
                {is4Events &&
                  <h2 className={channel === 'wap' ? 'articleName' : 'subtitleModuleDatos titleForm'}>
                    {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.datosdeDate.label')}
                  </h2>
                }
              </div>
              <div className="formBlock">
                <TextInput
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  htmlId="nombre4tabs"
                  label="Nombre"
                  required="true"
                  maxlength="100"
                  star="*"
                  name="firstName"
                  onChange={this.handleFieldChange}
                  value={this.state.firstName}
                  ref={nombre4events => (this.nombre4events = nombre4events)}
                  createEvent={true}
                />
              </div>
              {this.props.eventName !== eventType.Mascotas && (
                <>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="primer4tabs"
                      label="Primer Apellido"
                      required="true"
                      maxlength="100"
                      star="*"
                      name="lastName"
                      onChange={this.handleFieldChange}
                      value={this.state.lastName}
                      ref={primer4events => (this.primer4events = primer4events)}
                      createEvent={true}
                    />
                  </div>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="segundo4tabs"
                      label="Segundo Apellido"
                      required="false"
                      maxlength="100"
                      onChange={this.handleFieldChange}
                      name="motherName"
                      value={this.state.motherName}
                      ref={segundo4events => (this.segundo4events = segundo4events)}
                      createEvent={true}
                    />
                  </div>
                </>
              )}
            </div>
            {this.props.eventName === eventType.XV_Anos && (
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 moreOptionsWAP tooltipBackdropBoda">
                  <div className="formBlock moreOptionsWEB">
                    <div className="inLine whiteSpaceNoWrap">
                      <CheckBox htmlId={this.props.id + '_showEmail'} displayName={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.checkboxTxt.label')} ref={chk => this.showEmailData = chk} getSelectedValue={this.permitAccess} />
                    </div>
                    <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                      <img src={commonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={(e) => { this.handlePopUp(e, 'helpPopup'); }} />
                      <div className="tooltip-backdrop" />
                      <div id="helpPopup" className="popover bottom helpIconCssEmail">
                        <div className="arrow" />
                        <div className="popover-content">
                          
                          {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.celebritypopoverContent.label')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 moreOptionsWAP permitAccess" style={{ display: 'none' }} ref={(forCheck) => { this.forCheck = forCheck; }}>
                  <div className="formBlock">
                    <TextInput
                      doNotUpdateOnPropsChange="true"
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="cellularXvAnos"
                      label="Celular"
                      maxlength="10"
                      required="true"
                      star="*"
                      name="cellularXvAnos"
                      onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                      onPaste={(e) => { this.onPasteFunc(e); }}
                      onChange={this.handleFieldChange}
                      value={this.state.cellularXvAnos}
                      ref={cellularXvAnos => this.cellularXvAnos = cellularXvAnos}
                      createEvent={true}
                    />
                  </div>
                  <div className="formBlock">
                    <TextInput
                      doNotUpdateOnPropsChange="true"
                      className={`inputMaterial ${emailErrorCelebrity ? 'input-error' : ''}`}
                      labelClassName={`placeHolderMaterial ${emailErrorCelebrity ? 'label-error' : ''}`}
                      htmlId="emailXvAnos"
                      label="Correo electrónico"
                      type="tel"
                      maxlength="100"
                      required="true"
                      star="*"
                      onChange={this.handleFieldChange}
                      name="emailXvAnos"
                      value={this.state.emailXvAnos}
                      ref={emailXvAnos => this.emailXvAnos = emailXvAnos}
                      createEvent={true}
                    />
                  </div>
                  { emailErrorCelebrity && <span className="input-error-message" id="emailError">{emailErrorCelebrity}</span>}
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}